define('viewmodels/UserManual',['plugins/router', 'services/appsecurity', 'services/navigation', 'services/logger', 'services/AppRoutes', 'durandal/system', 'services/routeconfig', 'viewmodels/ChangePassword', 'viewmodels/GeneralSettings', 'services/utils'],
    function (router, appsecurity, navigation, logger, AppRoutes, system, routeconfig, changePassword, ObjGeneralSettings, utils) {
        var vm = {
            //UAt nm
            activate: function () {
            },
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            attached: attached,
            detached: detached,
            utils: utils,
            changePassword: changePassword,
            ObjGeneralSettings: ObjGeneralSettings,
            ClientDetails: ko.observableArray([]),
      
            NavigateToLogin: NavigateToLogin,
            ShowGeneralManual: ShowGeneralManual,
            UserSupportList: ko.observableArray([]),
            GeneralUserSupport: ko.observable(''),
            PrivacyContent: ko.observable(''),
            CookiesContent: ko.observable(''),
            TermsContent: ko.observable(''),
            ContactUsContent: ko.observable(''),
            LoggedInUser: ko.observable(false),
            forgotPassword: forgotPassword,
            forgetUserName: ko.observable(),
            errorMessage: ko.observable(''),
            ///
            GS_Cookies: ko.observable(),
            GS_MFA: ko.observable(),
            GS_GTR: ko.observable(),
            GS_ChangeName: ko.observable(),
            GS_ForgotUserName: ko.observable(),
            GS_OtherAssistance: ko.observable(),
            GS_LoginAssistance: ko.observable(),
            GS_ReqAccess: ko.observable(),
            GS_YourView: ko.observable(),
            //
            FAQSupportList: ko.observableArray([]),
            GenSupportList: ko.observableArray([]),
            PhoneNumber: ko.observable(),
            MaskedNumber: ko.observable(),
            OtpText: ko.observable(),
            loadJsFunctions: loadJsFunctions,
            LocaleCheckFlag: ko.observable(false),
            LocalizedIndexList: ko.observableArray([]),
            UserFAQHeaderList: ko.observableArray([]),
            UserFAQHeaderdupList: ko.observableArray([]),
            UserFAQParentChildList: ko.observableArray([]),
            MainUserSupportList: ko.observableArray([]),
            DocumentListFinal: ko.observableArray([]),
            GetUMSDocDetails: GetUMSDocDetails,
            RawSupportList: ko.observableArray([]),
            DownloadDocument: DownloadDocument,
            ResetDeloittePassword: ResetDeloittePassword,
            GetUMSDocDetailsFAQ: GetUMSDocDetailsFAQ,
            IsSSOUser: ko.observable(),
            ChangePhoneOpen: ChangePhoneOpen
        };
        return vm;

        function attached() {
            try {
                //password section buttons
                $('#SubmitoptionBtn').hide();
                $('#SubmitOTPBtn').hide();
                $('#changepasswordbtn').show();
                loadJsFunctions();
                //phone number section buttons
                $('#validateOTPButton').hide();
                $('#Authenticatebutton').hide();
                $('#submitbutton').show();

                $('#AttachmentContent').hide();
                if (vm.appsecurity != undefined && vm.appsecurity.userInfo() != undefined)
                    vm.LoggedInUser(true);
                else
                    vm.LoggedInUser(false);

                vm.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (vm.ObjGeneralSettings.LocalizedTextList() == undefined || vm.ObjGeneralSettings.LocalizedTextList() == null || vm.ObjGeneralSettings.LocalizedTextList().length <= 0 || vm.ObjGeneralSettings.LocalizedIndexList() == undefined || vm.ObjGeneralSettings.LocalizedIndexList() == null)
                        vm.LocaleCheckFlag(false);
                    else
                        vm.LocaleCheckFlag(true);
                });

                $("body").removeClass("login-page").addClass("login-container");
                $('body').addClass("login hold-transition");

                hideAll();
                if (!vm.LoggedInUser()) {
                    $('.main-header').hide();
                    $('.main-sidebar').hide();
                    GetUserManualList();
                }
                else {
                    vm.appsecurity.UserContent(vm.appsecurity.UserContent());
                    GetAllFAQLevels();
                }
               

                if (appsecurity.EmailId() != undefined && appsecurity.EmailId() != "undefined" && appsecurity.EmailId() != null && appsecurity.EmailId() != "") {
                GetIsSSOUserFlag();
                }
               
                if (vm.appsecurity.PhoneNumber() == undefined || vm.appsecurity.PhoneNumber() == null || vm.appsecurity.PhoneNumber() == "")
                    vm.PhoneNumber("");
                else {
                  
                    vm.PhoneNumber(vm.appsecurity.PhoneNumber());
                    $('#MessageDiv').show();
                    $('#PhoneNumeberdiv').hide();
                    var totallength = vm.PhoneNumber().substring(vm.PhoneNumber().length - 3, vm.PhoneNumber().length);
                    var countrycode = "+" + vm.PhoneNumber().substring(0, 2) + "-";
                    var completenumber = countrycode + "*****" + totallength;
                    vm.MaskedNumber(completenumber);
                }

                        
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function ChangePhoneOpen() {
            if (vm.appsecurity.UserContent() == 'changePhone-Pwd') {
                $("#Numberphonenumberchange").intlTelInput({
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "auto",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    preventInvalidNumbers: true,
                });

                $('#submitbutton').show();
            }
        }

        function GetIsSSOUserFlag() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/GetIsSSOUserFlag",
                    type: "POST",
                    headers: headers,
                    data: { Email: appsecurity.EmailId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetIsSSOUserFlag() in UserManual.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        vm.IsSSOUser(jsonResult);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '| Source : ajaxSuccess of GetIsSSOUserFlag() in UserManual.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                // ajaxFail code
            }
        }

        function GetPhoneNumber() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                return $.ajax({
                    url: "/api/Account/GetPhoneNumber",
                    type: "get",
                    headers: headers,
                    contentType: 'application/json',
                })
                    .success(function (jsonResult, status) {

                        if (jsonResult != null && jsonResult.length > 0 && !jsonResult[0].startsWith('INC')) {
                            vm.PhoneNumber(jsonResult[0]);
                            $('#Numberphonenumberchange').val(jsonResult[0]);
                            $('#numberprovider').val(jsonResult[0])
                            vm.MaskedNumber(jsonResult[1])
                           // vm.OtpText(vm.OtpText() + " " + jsonResult[1] + " " + (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('GetVerificationCodeMessage') == -1) ? 'with a verification code.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('GetVerificationCodeMessage')].Name());
                        }
                        else if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].startsWith('INC')) {
                                 var msg = 'An error occurred.Please contact your Application Administrator.';
                                 logger.logError(jsonResult[0] + " - " + msg, 'Error', system.getModuleId(vm), true);
                        }
                    })
                    .fail(function (error, status) {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in NavigatetoClientSpeceficPage() method in ProjectAuthorizeMFA.js';
                        logger.logMessage(msg);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetPhoneNumber() method in AuthorizeMFA.js';
                logger.logMessage(msg);
            }
        }


        function GetUserManualList() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetUserManualList",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                      
                        if (jsonResult == null || jsonResult.length == 0)
                            logger.logMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData') == -1) ? 'No data available for user support.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData')].Name(), 'Warning', system.getModuleId(vm), true);
                        else if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {
                            vm.UserSupportList([]);
                            vm.MainUserSupportList([]);
                            vm.FAQSupportList([]);
                            vm.GenSupportList([]);
                            vm.GeneralUserSupport('');
                            vm.TermsContent('');
                            vm.PrivacyContent('');
                            vm.CookiesContent('');
                            vm.ContactUsContent('');

                            var MappedGroupDetails = $.map(jsonResult, function (result) {
                                if (result.Is_GeneralSupport === '')
                                    return new UserSupportModel(result);
                            });

                            var MappedGenSupportList = $.map(jsonResult, function (result) {
                                if (result.Is_GeneralSupport === "1")
                                    return new UserSupportModel(result);
                            });

                            var MappedFAQList = $.map(jsonResult, function (result) {
                                if (result.Is_GeneralSupport === "0")
                                    return new UserSupportModel(result);
                            });

                            var MappedRawList = $.map(jsonResult, function (result) {
                                return new UserSupportModel(result);
                            });

                            var MappedMainGroupDetails = $.map(jsonResult, function (result) {
                                if (result.Group != '' && result.Group != null)
                                    return new UserSupportModel(result);
                            });
                            vm.MainUserSupportList(MappedMainGroupDetails);

                            vm.UserSupportList(MappedGroupDetails);
                            vm.FAQSupportList(MappedFAQList);
                            vm.GenSupportList(MappedGenSupportList);
                            vm.RawSupportList(MappedRawList);

                            for (var i = 0; i < vm.UserSupportList().length; i++) {

                                var contentType = vm.UserSupportList()[i].NameIdentifier();

                                switch (contentType) {
                                    case 'GeneralUserSupport':
                                        vm.GeneralUserSupport(vm.UserSupportList()[i].Description());
                                        break;
                                    case 'Terms':
                                        vm.TermsContent(vm.UserSupportList()[i].Description());
                                        break;
                                    case 'Privacy':
                                        vm.PrivacyContent(vm.UserSupportList()[i].Description());
                                        break;
                                    case 'Cookies':
                                        vm.CookiesContent(vm.UserSupportList()[i].Description());
                                        break;
                                    case 'ContactUs':
                                        vm.ContactUsContent(vm.UserSupportList()[i].Description());
                                        break;
                                }
                            }
                            if (!vm.LoggedInUser()) {
                                $('.main-header').hide();
                                $('.main-sidebar').hide();
                                if (vm.appsecurity.UserContent() == "forgotPwd-content") {
                                    ShowGeneralManual(vm.appsecurity.UserContent());
                                }
                                else {
                                    $("#guide-content").show();
                                    $('#nav_GeneralUserSupport').addClass("usermanual-active");
                                    $('#nav_Privacy').removeClass("usermanual-active");
                                    $('#nav_Cookies').removeClass("usermanual-active");
                                    $('#nav_Terms').removeClass("usermanual-active");
                                    $('#nav_faqList').removeClass("usermanual-active");
                                    var currentSet = ko.utils.arrayFilter(vm.RawSupportList(), function (item) {
                                        if (item.NameIdentifier() === "GeneralUserSupport") {
                                            return item;
                                        }
                                    });
                                    if (currentSet != undefined && currentSet[0] != undefined)
                                        GetUMSDocDetails(currentSet[0].ID(), "GeneralUserSupport");  // fetching docs of Userguide on first load
                                }
                            }
                            if (vm.LoggedInUser()) {
                                hideAll();
                                ShowGeneralManual(vm.appsecurity.UserContent())
                                if (vm.appsecurity.UserContent() === 'changePhone-Pwd')
                                    $("#changePhone-Pwd-content").show();
                                else {
                                    vm.appsecurity.UserContent('faqList');
                                    $("#mainFaq-content").show();
                                }

                                vm.MainUserSupportList().map((child) => {
                                    for (let parent of vm.UserFAQHeaderdupList()) {
                                        if (parent.TemplateDescription() == child.Group()) {
                                            if (!parent.children) {
                                                parent.children = [];
                                            }
                                            parent.children.push(child);
                                        }
                                    }
                                });
                                vm.UserFAQHeaderList([]);
                                vm.UserFAQHeaderList(vm.UserFAQHeaderdupList());
                            }
                        }
                        else if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            var msg = 'An error occurred.Please contact your Application Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + " - " + msg, 'Error', system.getModuleId(vm), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError') == -1) ? 'An error has occurred while fetching the User support list. Please contact your Administrator.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError')].Name(), 'Error', system.getModuleId(vm), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetUserManualList() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function UserSupportModel(item) {
            try {
                var self = this;
                self.ID = ko.observable(item.ID);
                self.ClientId = ko.observable(item.ClientId);
                self.Name = ko.observable($('<div/>').html(item.Name).text());
                self.NameIdentifier = ko.observable($('<div/>').html(item.Identifier).text());
                self.Is_GeneralSupport = ko.observable(item.Is_GeneralSupport);
                self.Description = ko.observable(item.Description);
                //if (item.Identifier === 'ContactUs')
                //    self.Description = ko.observable($('<div/>').html(item.Description).text());

                self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
                self.DocumentLink = ko.observable($('<div/>').html(item.DocumentLink).text());
                self.Group = ko.observable($('<div/>').html(item.Group).text());
                self.IsDocAvailable = ko.observable(item.IsDocAvailable);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in CalculationStatus.js';
                logger.logMessage(msg);
            }
        }

        function forgotPassword() {
            try {
                
                vm.errorMessage('');
                $('#PasswordMessageLabel').hide();
                if ($("#txtForgetUserName").val().length === 0) {
                    vm.errorMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('EmailAddressReq') == -1) ? 'Email address is required' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('EmailAddressReq')].Name()); 
                    $('#PasswordMessageLabel').removeClass('has-success').addClass('has-error');
                    $("#PasswordMessageLabel").show();
                }
                else if ($("#txtForgetUserName").val().length > 0 && !ValidateEmail($("#txtForgetUserName").val().toString()))
                {
                    vm.errorMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UsrEmailAddressVal') == -1) ? 'Please enter a valid email address.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UsrEmailAddressVal')].Name());
                    $('#PasswordMessageLabel').removeClass('has-success').addClass('has-error');
                    $("#PasswordMessageLabel").show();
                }
                else {
                    $('#loadingImgUser').show();
                    $('#fogotPasswordSubmit').hide();
                    $.ajax({
                        url: "/api/Account/ResetPassword",
                        type: "POST",
                        contentType: 'application/json',
                        data: JSON.stringify
                            ({
                                userName: vm.forgetUserName()
                            })
                    })
                        .success(ajaxSuccess)
                        
                        .fail(ajaxFail);
                        
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in forgotPassword() method in UserManual.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                            vm.errorMessage('');
                            $('#loadingImgUser').hide();
                            $('#fogotPasswordSubmit').show();
                    $('#PasswordMessageLabel').removeClass('has-error').addClass('has-success');
                            vm.errorMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ResetPasswrodSuccessMessage') == -1) ? 'If the supplied user exists. An e-mail has been sent to the e-mail address associated with the user.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ResetPasswrodSuccessMessage')].Name());
                            $('#PasswordMessageLabel').show();
                }
                catch (e) {
                    var msg = 'Exception:' + e + '| Source : ajaxSuccess of forgotPassword() in UserManual.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    // ajaxFail code
                    vm.errorMessage('');
                    $('#loadingImgUser').hide();
                    $('#fogotPasswordSubmit').show();
                    $('#PasswordMessageLabel').removeClass('has-success').addClass('has-error');
                    vm.errorMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ResetPasswrodFailMessage') == -1) ? 'This operation is not valid for the user' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ResetPasswrodFailMessage')].Name());
                    $('#PasswordMessageLabel').show();
                }
                catch(e)
                {
                    var msg = 'Exception:' + e + '| Source : ajaxSuccess of forgotPassword() in UserManual.js';
                    logger.logMessage(msg);
                }
            }

        }

        function ValidateEmail(email) {

            try {
                var validRegex = "[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+";

                if (email.match(validRegex)) 

                    return true;

                else 

                    return false;
            }
            catch(e)
            {
                var msg = 'Exception: ' + e + ' | Source: ValidateEmail() method in UserManual.js';
                logger.logMessage(msg);
            }
        }
        function NavigateToLogin() {
            try {
                vm.appsecurity.UserContent('');
                router.navigate('login');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToLogin() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //$("body").removeClass("login").addClass("login-container");
                //$('body').addClass("login-page hold-transition");
                //$("header").css({ "display": "block" });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in UserManual.js';
                logger.logMessage(msg);
            }
        }

        function ShowGeneralManual(data) {
            try {
                
                $('#AttachmentContent').hide();
                $('#nav_GeneralUserSupport').removeClass("usermanual-active");
                $('#nav_Privacy').removeClass("usermanual-active");
                $('#nav_Cookies').removeClass("usermanual-active");
                $('#nav_Terms').removeClass("usermanual-active");
                $('#nav_faqList').removeClass("usermanual-active");

                
                var currentSet = ko.utils.arrayFilter(vm.RawSupportList(), function (item) {
                    if (item.NameIdentifier() === data) {
                        return item;
                    }
                });
                if (currentSet != undefined && currentSet[0] != undefined && data != 'faqList')
                    GetUMSDocDetails(currentSet[0].ID(), data);

                vm.appsecurity.UserContent(data);
                hideAll();
                if (data != undefined) {

                    switch (data) {
                        case 'GeneralUserSupport':
                            $("#guide-content").show();
                            break;
                        case 'Privacy':
                            $("#privacy-content").show();
                            break;
                        case 'Cookies':
                            $("#cookies-content").show();
                            break;
                        case 'Terms':
                            $("#terms-content").show();
                            break;
                        case 'forgotPwd-content':
                            $("#forgotPwd-content").show();
                            break;
                        case 'faqList':
                            $("#mainFaq-content").show();
                            break;
                        case 'changePhone-Pwd':
                            $("#changePhone-Pwd-content").show();
                            break;
                        default:
                            $("#mainFaq-content").show();
                            break;
                    } 
                    $('#nav_' + data).addClass("usermanual-active");

                }                    
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowGeneralUserGuide() method in UserManual.js';
                logger.logMessage(msg);
            }
        }
      
        function hideAll() {
            $("#mainFaq-content").hide();
            $("#cookies-content").hide();
            $("#privacy-content").hide();
            $("#guide-content").hide();
            $("#terms-content").hide(); 
            $("#forgotPwd-content").hide();
            $("#changePhone-Pwd-content").hide();
        }

        function loadJsFunctions() {
            $('#txtNewPAssword').keyup(function () {
                var pswd = $(this).val();
                //validate lower case letter
                if (pswd.match(/[a-z]/)) {
                    $('#lblLowerCase').removeClass('invalid').addClass('valid');
                    $('#lblLowerCase>i').removeClass('fa-close').addClass('fa-check');
                } else {
                    $('#lblLowerCase').removeClass('valid').addClass('invalid');
                    $('#lblLowerCase>i').removeClass('fa-check').addClass('fa-close');
                }
                //validate upper case letter
                if (pswd.match(/[A-Z]/)) {
                    $('#lblUpperCase').removeClass('invalid').addClass('valid');
                    $('#lblUpperCase>i').removeClass('fa-close').addClass('fa-check');
                } else {
                    $('#lblUpperCase').removeClass('valid').addClass('invalid');
                    $('#lblUpperCase>i').removeClass('fa-check').addClass('fa-close');
                }
                //validate number
                if (pswd.match(/\d/)) {
                    $('#lblNumber').removeClass('invalid').addClass('valid');
                    $('#lblNumber>i').removeClass('fa-close').addClass('fa-check');
                } else {
                    $('#lblNumber').removeClass('valid').addClass('invalid');
                    $('#lblNumber>i').removeClass('fa-check').addClass('fa-close');
                }
                //validate punctuation
                if (checkSpecialCharacters(pswd)) {
                    $('#lblPunctuation').removeClass('invalid').addClass('valid');
                    $('#lblPunctuation>i').removeClass('fa-close').addClass('fa-check');
                } else {
                    $('#lblPunctuation').removeClass('valid').addClass('invalid');
                    $('#lblPunctuation>i').removeClass('fa-check').addClass('fa-close');
                }
                //validate the length
                if (pswd.length < 10) {
                    $('#lblLength').removeClass('valid').addClass('invalid');
                    $('#lblLength>i').removeClass('fa-check').addClass('fa-close');
                } else {
                    $('#lblLength').removeClass('invalid').addClass('valid');
                    $('#lblLength>i').removeClass('fa-close').addClass('fa-check');
                }
                //validate the better length
                if (pswd.length >= 12) {
                    $('#lblBetterLength').removeClass('invalid').addClass('valid');
                    $('#lblBetterLength>i').removeClass('fa-close').addClass('fa-check');
                } else {
                    $('#lblBetterLength').removeClass('valid').addClass('invalid');
                    $('#lblBetterLength>i').removeClass('fa-check').addClass('fa-close');
                }
            }).focus(function () {
                $('#pswd_info').show();
            }).blur(function () {
                $('#pswd_info').hide();
            });
        }

        function checkSpecialCharacters(data) {
            try {
                var iChars = "!@#$%^&*()+=-[]\\\';,./{}|\":<>?~_";
                for (var i = 0; i < data.length; i++) {
                    if (iChars.indexOf(data.charAt(i)) != -1) {
                        return true;
                    }
                }
                return false;
            }
            catch (e) {
               // logger.logError("Error in method: checkSpecialCharacters", null, data, false);
            }
        }

        function GetAllFAQLevels() {
            try {

                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetFAQHeaderList",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {

                        if (jsonResult == null || jsonResult.length == 0) {
                            vm.UserFAQHeaderdupList([]);
                            logger.logMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData') == -1) ? 'No data available for user support.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoUserSupportData')].Name(), 'Warning', system.getModuleId(vm), true);
                        }
                        else  {
                            vm.UserFAQHeaderdupList([]);

                            var MappedGenSupportList = $.map(jsonResult, function (result) {
                                return new UserFAQHeaderModel(result);
                            });

                            vm.UserFAQHeaderdupList(MappedGenSupportList);

                            GetUserManualList();
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError') == -1) ? 'An error has occurred while fetching the User support list. Please contact your Administrator.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('UserManualContactAdminError')].Name(), 'Error', system.getModuleId(vm), true);
                    })

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllBusinessLevels() method in OrganizationalLevels.js';
                logger.logMessage(msg);
            }

        }

        function UserFAQHeaderModel(item) {
            try {
                var self = this;
                self.TemplateId = ko.observable(item.TemplateId);
                self.TemplateName = ko.observable($('<div/>').html(item.TemplateName).text());
                self.TemplateDescription = ko.observable($('<div/>').html(item.TemplateDescription).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserFAQHeaderModel() method in usermanual.js';
                logger.logMessage(msg);
            }
        }
        ///////////////////////////////////////////////-Change password -- ////////////////////////////


        //Docuemnt section strats
        function GetUMSDocDetails(ID, Type) {
            try {
                try {
                   
                    $.ajax({
                        url: "/api/Configuration/GetUMSComments",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: { TemplateId: ID, CommentType: 'UMSD' }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null && jsonResult != undefined && jsonResult != '' ) {
                            var mappedDocDetails = $.map(jsonResult, function (result) {
                                return new ReportDetailsModel(result);
                            });

                            vm.DocumentListFinal([]);
                            vm.DocumentListFinal(mappedDocDetails);

                            if (vm.DocumentListFinal() != undefined && vm.DocumentListFinal().length > 0) {
                                var docContent =

                                    '<h6 class="card-title pl-2">Attachments</h6>'
                                for (i = 0; i < vm.DocumentListFinal().length; i++) {
                                    docContent += '<div class="col-lg-12 atachmentSubBox"> ' +
                                        '<div class="card-body"> ' +
                                        '<span> <i class="demo-icon icon-paperclip_special"></i> <span id="name_' + vm.DocumentListFinal()[i].DocId() + '">' + vm.DocumentListFinal()[i].DocumentName() + '</span></span> ';
                                    if (vm.DocumentListFinal()[i].DocComments() == "")
                                        docContent += '<p class="bg-white col-lg-12 mb-1"> </p> ';
                                    else
                                        docContent += '<p class="bg-white col-lg-12 mb-1">' + vm.DocumentListFinal()[i].DocComments() + ' </p> ';
                                    docContent += '<span class="font-weight-bold mr-2 mb-3">' + vm.DocumentListFinal()[i].UserName() + '</span> on <span>' + vm.DocumentListFinal()[i].UploadedDate() + '</span> ' +
                                        '<span style="display:none;" id="path_' + vm.DocumentListFinal()[i].DocId() + '">' + vm.DocumentListFinal()[i].DocPath() + '</span>' +
                                        '<span class="c-actions" title = "Click to Download the Document" id="Down_umsd_' + vm.DocumentListFinal()[i].DocId() + '" data-bind="click: function(data, event) { $root.DownloadDocument()}"> <i class="demo-icon icon-download_special"></i> Download</span > ' +
                                        ' </div> ' +
                                        '</div> '
                                }

                                //if (Type === 'faqList') {
                                //    $('#AttachmentContent_' + ID).html(docContent);
                                //    $('#AttachmentContent_' + ID).show();
                                //} else {
                                $('#AttachmentContent_' + Type).html(docContent);
                                $('#AttachmentContent_' + Type).show();
                                //}
                                for (k = 0; k < vm.DocumentListFinal().length > 0; k++) {
                                    ko.applyBindingsToNode($('#Down_umsd_' + vm.DocumentListFinal()[k].DocId()), { click: vm.DownloadDocument });
                                }
                            } else {
                                HideAllAttachments();
                            }

                        }
                        else  {
                            HideAllAttachments();
                        }
        
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        
        function GetUMSDocDetailsFAQ(ID) {
            try {
                try {

                    if ($('#collapse' + ID)[0].className.indexOf("show") != -1)
                        return false;

                    $.ajax({
                        url: "/api/Configuration/GetUMSComments",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        data: { TemplateId: ID, CommentType: 'UMSD' }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, error) {
                    try {
                        if (jsonResult != null && jsonResult != undefined && jsonResult != '') {
                            var mappedDocDetails = $.map(jsonResult, function (result) {
                                return new ReportDetailsModel(result);
                            });

                            vm.DocumentListFinal([]);
                            vm.DocumentListFinal(mappedDocDetails);

                            if (vm.DocumentListFinal() != undefined && vm.DocumentListFinal().length > 0) {
                                var docContent =

                                    '<h6 class="card-title pl-2">Attachments</h6>'
                                for (i = 0; i < vm.DocumentListFinal().length; i++) {
                                    docContent += '<div class="col-lg-12 atachmentSubBox"> ' +
                                        '<div class="card-body"> ' +
                                        '<span> <i class="demo-icon icon-paperclip_special"></i> <span id="name_' + vm.DocumentListFinal()[i].DocId() + '">' + vm.DocumentListFinal()[i].DocumentName() + '</span></span> ' +
                                        '<p class="bg-white col-lg-12 mb-1">' + vm.DocumentListFinal()[i].DocComments() + ' </p> ' +
                                        '<span class="font-weight-bold mr-2 mb-3">' + vm.DocumentListFinal()[i].UserName() + '</span> on <span>' + vm.DocumentListFinal()[i].UploadedDate() + '</span> ' +
                                        '<span style="display:none;" id="path_' + vm.DocumentListFinal()[i].DocId() + '">' + vm.DocumentListFinal()[i].DocPath() + '</span>' +
                                        '<span class="c-actions" title = "Click to Download the Document" id="Down_umsd_' + vm.DocumentListFinal()[i].DocId() + '" data-bind="click: function(data, event) { $root.DownloadDocument()}"> <i class="demo-icon icon-download_special"></i> Download</span > ' +
                                        ' </div> ' +
                                        '</div> '
                                }

                                    $('#AttachmentContent_' + ID).html(docContent);
                                    $('#AttachmentContent_' + ID).show();
                                
                                for (k = 0; k < vm.DocumentListFinal().length > 0; k++) {
                                    ko.applyBindingsToNode($('#Down_umsd_' + vm.DocumentListFinal()[k].DocId()), { click: vm.DownloadDocument });
                                }
                            } else {
                                HideAllAttachments();
                            }

                        }
                        else{
                            HideAllAttachments();
                        }
           
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();

                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }
        function HideAllAttachments() {
                $('.AttachmentContent_Class').hide();
        }

        function ReportDetailsModel(item) {
            try {
                var self = this;
                self.DocId = ko.observable($('<div/>').html(item.CommentId).text());
                self.DocComments = ko.observable($('<div/>').html(item.CommentText).text());
                self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text())
                self.UserName = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.DocPath = ko.observable($('<div/>').html(item.DocumentPath).text());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function DownloadDocument(data, event) {
            try {
                if (event.currentTarget != undefined) {
                    var DocumentId = event.currentTarget.id.split('_');
                   
                    var test = $.ajax({
                        url: "/api/Configuration/CheckFileIfExist",
                        type: "Get",
                        headers: appsecurity.getSecurityHeaders(),
                        data: { CommentId: DocumentId[2], FileName: $('#name_' + DocumentId[2]).text(), FilePath: $('#path_' + DocumentId[2]).text() }
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail)
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {

                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: $('#path_' + DocumentId[2]).text(), FileName: $('#name_' + DocumentId[2]).text()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
                    }
                    else{
                        logger.logError(vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('ActionCantPerformMessage')].Name, [" " + (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload') == -1) ? 'The requested document is not available for download. Please contact your Application Administrator.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('NoRequestedDocForDownload')].Name], 'Error', system.getModuleId(vm), true);
                    }

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn secondary-btn", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }

        function ResetDeloittePassword() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;

                $.ajax({
                    url: "/api/Account/ResetDeloittePassword",
                    type: "POST",
                    headers: headers,
                    data: { Email: appsecurity.EmailId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in ResetDeloittePassword() in UserManual.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult) {
                       // vm.IsSSOUser(jsonResult);
                        logger.logSuccess('Reset Password link is sent to the registered email address.', 'Success', system.getModuleId(vm), true);
                    }
                    else {
                        logger.logError('An error has occurred. Please contact Application Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '| Source : ajaxSuccess of ResetDeloittePassword() in UserManual.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                // ajaxFail code
            }
        }

    });



